<slick-dialog #dialogRef header="Edit Positions" width="600" top="140">

	<table class="js-table">
		<colgroup>
			<col />
			<col style="width: 60px" />
		</colgroup>
		<thead>
			<tr>
				<td>Position Name</td>
				<td>Active</td>
			</tr>
		</thead>

		<tbody>
			<tr *ngFor="let role of roles">
				<td>
					<input type="text" class="form-control" style="height: 28px;" [disabled]="role.roleName === 'Agent' || role.roleName === 'Adjuster'" [(ngModel)]="role.roleName" />
					<form-error *ngIf="isSubmitted && role.businessDevelopmentContactRoleId > 0 && !role.roleName">Position Name is required</form-error>
				</td>
				<td *ngIf="role.roleName === 'Agent' || role.roleName === 'Adjuster'" style="text-align: center"><input type="checkbox" disabled checked style="margin-top: 6px;" /></td>
				<td *ngIf="role.roleName !== 'Agent' && role.roleName !== 'Adjuster'" style="text-align: center">
					<input type="checkbox" [(ngModel)]="role.active"  style="margin-top: 6px;" />
				</td>
			</tr>
		</tbody>
	</table>

	<button class="btn btn-link" (click)="addNewRole()"><i class="far fa-plus"></i> Add New Role</button>
	<slick-dialog-footer>
		<button type="button" [slick-button-spinner]="spinnerStatus" class="btn btn-outline-primary save-button" (click)="onSave()"><i class="far fa-save"></i>&nbsp;Save</button>
		<button type="button" class="btn btn-outline-danger cancel-button" (click)="onCancel()"><i class="far fa-ban"></i>&nbsp;Cancel</button>
	</slick-dialog-footer>
</slick-dialog>